module.exports = __webpack_public_path__ + "static/media/Thumbs.83e0c0d9.db";